var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-body-2 blue lighten-5",attrs:{"id":"searchField"},on:{"click":_vm.gotoSearch}},[_vm._v(" Cari event apapun "),_c('v-icon',{staticClass:"float-right"},[_vm._v("search")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }